// extracted by mini-css-extract-plugin
module.exports = {"dragdrop":"contract-document-lang-file-upload_dragdrop_1wyh8","noUploading":"contract-document-lang-file-upload_noUploading_2Ou6T"};